<template>
  <div class="block-wrap block-specification" style="padding: 10px" v-loading="!hasReRender">
    <template v-if="hasReRender">
      <div v-for="(s, sindex) in specifications" :key="sindex">
        <div class="title-bg">
          规格名：
          <template
            v-if="s.renderType && s.renderType === 'select'"
          >
            <el-select
              v-model="s.name"
              style="width: 140px"
              @change="e => nameChange(s)" 
            >
              <template v-for="(op, opIndex) in s.renderOptions">
                <el-option :key="opIndex" :label="op.sellPropertyName" :value="op.sellPropertyName" />
              </template>
            </el-select>
          </template>
          <el-input
            v-else
            :disabled="specNameDisabled(s)"
            style="width: 140px"
            v-model="s.name"
            @keyup.enter.native="e => nameEnter(sindex)"
            :maxlength="20"
            @change="e => nameChange(s)" 
          />
          <span v-if="s.valueItemRule.supportDiy && isSelect(s.valueItemRule.valueDisplayStyle)" style="margin-left: 40px;font-size: 12px;"><i class="el-icon-warning" style="font-size: 16px; color: #E6A23C;"></i>该规格下规格值支持<span style="color: #E6A23C;">自定义</span></span>
          <el-button
            v-if="remarkKey && s.valueItemRule.supportRemark"
            style="float: right; margin-right: 8px"
            type="link"
            @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
          <el-button style="float: right" :disabled="(s.valueItemRule && s.valueItemRule.isRequired)" type="link" @click="removeSpName(sindex)">删除</el-button>
        </div>
        <div class="specification-value">
          <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
          <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" filter=".drag-ignore_item" handle=".drag-icon-wrap"  :group="{ name: s.name, pull: 'clone', put: false }" :animation="500">
            <template v-for="(v, vi) in specifications[sindex].values">
              <el-form
                ref="specValueForm"
                :key="vi"
                :model="v"
                inline
              >
                <div class="specification-value-flex_item" v-if="s.valueItemRule">
                  <el-form-item prop="value" :rules="genFormItemRule(v, s)">
                    <div class="del-input-wrap">
                      <!-- 级联选择组件 暂时废弃 -->
                      <!-- <template v-if="s.valueItemRule.valueDisplayStyle === 'cascader'">
                        <Cascader
                          v-model="v.value"
                          :navigations="s.valueItemRule.navigationProperties"
                          :ruleParams="ruleParams"
                          :showValue="v.fxgExtra.showValue"
                          :getData="getCascadeValues"
                          @change="(data) => handleCascaderValueChange(data, v)"
                        />
                      </template> -->
                      <template  v-if="isSelect(s.valueItemRule.valueDisplayStyle)">
                        <el-select
                          :ref="`${sindex}-${vi}`"
                          placeholder="请选择"
                          v-model="v.value"
                          :allow-create="s.valueItemRule.supportDiy"
                          :blur-create="s.valueItemRule.supportDiy"
                          filterable
                          style="width: 160px"
                          remote
                          :remote-method="q => handleSearchPropertyValues(q, s.valueItemRule)"
                          @focus="hanldeSelectorFocus(s.valueItemRule)"
                          @change="e => handleValueChange(v)"
                        >
                          <template v-for="op in s.valueItemRule.propertyValues.slice(0, 100)">
                            <el-option
                              :key="op.sellPropertyValueName"
                              :label="op.sellPropertyValueName"
                              :value="op.sellPropertyValueName"
                              :disabled="s.values.findIndex(_v => _v.value === op.sellPropertyValueName) > -1"
                            />
                          </template>
                        </el-select>
                      </template>
                      <template v-else-if="s.valueItemRule.measureTemplates && s.valueItemRule.measureTemplates.length > 0">
                        <MeasureInfo
                          :formData="v"
                          :measureTemplates="s.valueItemRule.measureTemplates"
                          @change="e => handleValueChange(v)"
                        />
                      </template>
                      <template v-else>
                        <el-input
                          :ref="`${sindex}-${vi}`"
                          :disabled="disabledSpValue || isPureType"
                          placeholder="请输入"
                          @blur="e => blurHandle(sindex, vi, e)"
                          class="specification-value-flex_input"
                          @keyup.enter.native="e => valueEnter(sindex, vi)"
                          @input="e => valueInput(v)"
                          v-model="v.value"
                        />
                      </template>
                      <!-- <el-checkbox
                        style="margin-left: 8px"
                        v-model="v.checked"
                        @change="onChangeCheckbox"
                        :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"
                      ></el-checkbox> -->
                      <div @click="removeSpValue(sindex, vi, v)" class="del-btn">
                        <i class="el-icon-close" />
                      </div>
                      <drag-item-content></drag-item-content>
                    </div>
                  </el-form-item>
                  <div v-if="remarkKey && s.valueItemRule.supportRemark" class="remarkWrap">
                   <el-form-item :prop="remarkKey" :rules="genFormItemRemarkRule(v, s)">
                    <el-input
                      class="input-remark"
                      :ref="`${sindex}-${vi}-remark`"
                      placeholder="规格备注"
                      :disabled="isPureType"
                      @input="remarkInput(v, vi, sindex)"
                      v-model="v[remarkKey]"
                    ></el-input>
                   </el-form-item>
                  </div>
                  <div v-if="sindex === 0" class="specification-value-flex_img">
                   <el-form-item prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                    <ImgUpload
                      :ref="`${sindex}-${vi}-img`"
                      :width="80"
                      :height="80"
                      :file="v.imageUrl"
                      :limitSize="isCheckImg ? 5 * 1024 * 1024 : 0"
                      :aspectRatio="isCheckImg ? 1 : 0"
                      aspectRatioText="1:1"
                      :limitSuffix="imgLimitSuffix"
                      :size="150"
                      :isSingle="true"
                      :isPureType="isPureType"
                      :show-audit-result="showAuditResult"
                      :auditFileList="auditFileList"
                      :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                      @upload-success="(url) => imageUploadSuccess(url, v, vi)"
                      @del="() => imageUploadDel(v)"
                    />
                   </el-form-item>
                  </div>
                </div>
              </el-form>
            </template>
            <!-- <div v-if="!specifications[sindex].values || specifications[sindex].values.length === 0" class="tips ft-12">
              <span style="color: red">请先去基础资料里维护对应的规格</span>
            </div> -->
            <div
              v-if="specifications[sindex].values.length <= specSingleLimit" 
              class="specification-value-flex_item drag-ignore_item"
            >
              <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
            </div>
          </vue-draggable>
          <div class="tips ft-12 ml_70" v-if="sindex === 0">
            <span>默认取商品第一张主图，买家选择不同规格会看到对应规格图片，图片大小不超过5M，长宽比为1:1，建议尺寸：800 x 800像素，建议格式：png，jpg，jpeg格式</span>
          </div>
          <!-- <div class="tips ft-12" v-if="checkSize && needSizeList.length && (s.name.includes('尺码') || s.name.includes('鞋码'))" style="color:#F56C6C;display:block">
            <span>尺码模板中缺少尺码 {{needSizeList}} 信息，请补充！</span>
            <el-button type="text" @click="setSize">前往配置</el-button>
          </div> -->
        </div>
      </div>
      <div v-if="computeUnrenderSpecList && computeUnrenderSpecList.length > 0" class="add-sku-tips">
        <div>
          <span>您还可以维护规格</span>
          <template v-for="(item, index) in computeUnrenderSpecList">
            <span :key="index">
              「{{ item.sellPropertyName }}」
            </span>
          </template>
          <span>，</span>
          <template v-if="unrenderRequiredSpecList.length > 0">
            <span>其中规格</span>
            <template v-for="(item, index) in unrenderRequiredSpecList">
              <span :key="index" style="color: red;">
                「{{ item.sellPropertyName }}」
              </span>
            </template>
            <span>平台要求为必填，为避免铺货失败</span>
          </template><span>请进行添加</span>
        </div>
      </div>
      <div v-else-if="!supportPropertyDiy && (computeNeedLessSpecList.length > 0)" class="add-sku-tips">
        <div>
          <span>平台不支持规格</span>
          <template v-for="(item, index) in computeNeedLessSpecList">
            <span :key="index" style="color: red;">
              「{{ item.name }}」
            </span>
          </template>
          <span>，请删除</span>
        </div>
      </div>
    </template>
    <!-- v-if="supportPropertyDiy" -->
    <div v-show="showAddSpNameBtn"  class="title-bg">
      <el-button @click="handleAddSpName" :disabled="isPureType">添加商品规格</el-button>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';
import { getImgFileSize } from '@/api/base/index.js';
import { gernerateSpecItem, gernerateDefaultSpecValueItem, formatSpecValues } from './service';
import Cascader from './Cascader.vue';
import MeasureInfo from './MeasureInfo.vue';
import { fxgGetCategoryPropertyValue } from '@/api/prod/center';
import { cloneDeep } from 'lodash';
import TemplateSelect from '@/print/components/PrintExpressDialog/components/templateSelect.vue';
import genkey from '@/utils/genkey.js'
import { dragItemMixin } from '../../utils/mixins';

export default {
  inject: {
    isGroupPuhuo: {
      default: false,
    },
    disabledSpName: {
      default: false,
    },
    disabledSpValue: {
      default: false,
    },
    noSpPic: {
      default: false
    },
  },
  components: {
    ImgUpload,
    Cascader,
    MeasureInfo,
    TemplateSelect,
    BatchSetSpecRemarksDialog,
  },
  model: {
    prop: 'values',
    event: 'change',
  },
  mixins: [dragItemMixin],
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    // 未渲染的规格列表
    unrenderSpecList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 不需要渲染的规格
    needlessSpecList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 平台返回的强校验规格信息
    requiredSpecDetails: {
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: { // 打开基础资料编辑
      type: Function,
      default: () => {}
    },
    imgLimitSuffix: {
      // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif',
    },
    supportPropertyDiy: {
      type: Boolean, // 是否支持自定义
      default: false,
    },
    maxSpecNumLimit: {
      type: Number, // 最大规格数量
      default: 5,
    },
    specSingleLimit: {
      type: Number, // 最大规格值数量
      default: 5,
    },
    ruleParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    remarkKey: {
      type: String,
      default: '',
    },
    pureType: {
      type: Number,
      default: 0,
    },
    showAuditResult: {
      type: Boolean,
      default: false
    },
    auditFileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // sizeTemplateList:{
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // checkSize: Boolean,
    isCheckImg:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      specifications: [],
      // specialSizeList:[], // 将X,XL,S等尺码集合在一起
      // needSizeList:[], // 需要在尺码模板维护的尺码
      showAddSkuTips: true,
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
      isPureType: false,
      hasReRender: true,
      // selected_size:[],
    };
  },
  computed: {
    computeUnrenderSpecList() {
      const filterList =  this.unrenderSpecList.filter(item => {
        return !this.specifications.some(spec => {
          return spec.name === item.sellPropertyName
        })
      });
      return filterList;
    },
    unrenderRequiredSpecList() {
      const filterList =  this.unrenderSpecList.filter(item => {
        return item.isRequired === true;
      }).filter(item => {
        return !this.specifications.some(spec => {
          return spec.name === item.sellPropertyName
        })
      });
      return filterList;
    },
    computeNeedLessSpecList() {
      if (this.supportPropertyDiy) {
        return [];
      }
      const filterList = this.needlessSpecList.filter(item => {
        return this.specifications.some(spec => {
          return spec.name === item.name
        })
      });
      return filterList;
    },
    showAddSpNameBtn() {
      if (this.specifications.length < this.requiredSpecDetails.length) {
        return true;
      }
      if (this.supportPropertyDiy && this.specifications.length < this.maxSpecNumLimit) {
        return true;
      }
      return false;
    },
  },
  watch: {
    values: {
      handler(v) {
        this.specifications = v;
        // 初始化
        // this.getNeedSize();
        this.$forceUpdate();
      },
      immediate: true,
    },
    pureType: {
      handler(val) {
        this.isPureType = val === 0 ? false : true;
      },
      immediate: true,
    },
    // sizeTemplateList: {
    //   handler(list) {
    //     this.getSelectList(list);
    //   },
    //   immediate: true,
    // }
  },
  mounted() {
    const noTips = localStorage.getItem('noSecTips');
    if (noTips === '1') {
      this.showAddSkuTips = false;
    }
    

  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey,
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    specNameDisabled(specItem) {
      const { valueItemRule } = specItem;
      if (valueItemRule.isRequired === true) {
        return true;
      }
      if (this.supportPropertyDiy) {
        return false;
      }
      if (specItem.editPropertyName) {
        return false;
      }
      if (valueItemRule.supportDiy === true) {
        return false;
      }
      return true;
    },
    // getSelectList(list){
    //   let componentData = list[0]?.componentData;
    //   let selected_size = componentData && JSON.parse(componentData).selected_size || [];
    //   this.selected_size = selected_size;
    // },
    // getNeedSize(list){
    //   if(list){
    //     this.getSelectList(list)
    //   };

    //   this.specialSizeList=[];
    //   if(this.specifications?.length){
    //     this.specifications.forEach(item=>{
    //       /**
    //        * 如果下发的是尺码大小和鞋码大小，且支持自定义的情况，不校验尺码
    //        * 尺码大小 4704
    //        * 鞋码大小 4709
    //        */
    //       let needCheck = true
    //       if((item.id === 4704 || item.id===4709) && item.valueItemRule.supportDiy){
    //         needCheck = false
    //       }
          
    //       if((item.name?.includes('尺码') || item.name?.includes('鞋码')) && needCheck ){
    //         item.values.forEach(i=>{
    //           this.specialSizeList.push(i.value);
    //         })
    //       }
    //     })
    //   }

    //   this.needSizeList=this.specialSizeList;
    //   this.selected_size.forEach((item)=>{
    //     if(this.specialSizeList.includes(item)){
    //       this.needSizeList = this.needSizeList.filter(i=>i!==item);
    //     }
    //   })

    //   this.$emit('get-need-size', this.needSizeList)
    // },
    // setSize(){
    //   this.$emit('show-add-size')
    // },
    isSelect(valueDisplayStyle) {
      return ['cascader_multi_select', 'cascader', 'select', 'checkbox'].includes(valueDisplayStyle)
    },
    // 刷新组件重新渲染
    reRenderPage() {
      this.hasReRender = false;
      setTimeout(() => {
        this.hasReRender = true;
      }, 300);
    },
    genFormItemRule(valueItem, specItem) {
      const {  valueItemRule = {} } = specItem;
      const { valueDisplayStyle, measureTemplates = [], } = valueItemRule;
      let valueValidator = (rule, value, callback) => {
        if (!valueItem.value) {
          return callback(new Error('请填写规格值'))
        }
        callback();
      }
      // 度量衡的校验规则
      if (measureTemplates.length > 0) {
        valueValidator = (rule, value, callback) => {
          if (!valueItem.value) {
            return callback(new Error('请填写规格值'))
          }
          let validReult = true;
          const { measureInfo = {} } = valueItem.fxgExtra;
          const { values = [] } = measureInfo
          for (let i = 0; i < values.length; i++) {
            const measureItem = values[i];
            if (!measureItem.value) {
              validReult = '请填写度量衡项值';
              break;
            }
            if ((measureItem.units.length > 0) && !measureItem.unitId) {
              validReult = '请填写度量衡项单位值';
              break;
            }
          }
          if (validReult !== true) {
            return callback(new Error(validReult))
          }
          callback();
        }
      } else if (this.isSelect(valueDisplayStyle)) {
        let { propertyValues = [], supportDiy } = valueItemRule;
        if (valueItemRule._propertyValues) {
          propertyValues = [...(valueItemRule._propertyValues || [])];
        }
        valueValidator = (rule, value, callback) => {
          if (!valueItem.value) {
            return callback(new Error('请填写规格值'))
          }
          if (supportDiy) {
            return callback();
          }
          const hasMatchValue = propertyValues.some(item => {
            return item.sellPropertyValueName === valueItem.value;
          });
          if (!hasMatchValue) {
            return callback(new Error('规格值匹配失败，请重新选择'))
          }
          callback();
        }
      }
      // else if (['cascader'].includes(valueDisplayStyle)) {
      //   // 级联选择器
      //   valueValidator = (rule, value, callback) => {
      //     console.log('valuess===>', value)
      //     if (!valueItem.value) {
      //       return callback(new Error('请填写规格值'))
      //     }
      //     if (!valueItem.fxgExtra.showValue) {
      //       return callback(new Error(`规格值匹配失败，请重新选择`))
      //     }
      //     callback();
      //   }
      // }
      return [
        {
          required: true,
          validator: valueValidator
        }
      ];
    },
    genFormItemRemarkRule(valueItem, specItem) {
      let valueValidator = (rule, value, callback) => {
        if (valueItem[this.remarkKey] && valueItem[this.remarkKey]?.length > 18) {
          return callback(new Error('规格备注不超过18个字'))
        }
        callback();
      }
      return [
        {
          validator: valueValidator, trgger: 'change'
        }
      ];
    },
    genFormItemImgRule(valueItem, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        const refImg = this.$refs[ref]
        if (valueItem.imageUrl && refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage()
          if(errMsg) {
            return callback(new Error(errMsg))
          } else {
            callback();
          }
        }
        callback();
      }
      return [
        {
          required: true,
          validator: valueValidator
        }
      ];
    },
    validateSpecLimit() {
      const result = true;
      if (this.unrenderRequiredSpecList.length > 0) {
        const { sellPropertyName } = this.unrenderRequiredSpecList[0];
        return `规格「${sellPropertyName}」必须维护`;
      }
      if (this.specifications.length > this.maxSpecNumLimit) {
        return `该类目下可配置规格最大数量为${this.maxSpecNumLimit}`;
      }
      const valuesIsNull = this.specifications.find(item => {
        return item.values.length === 0;
      });
      if (valuesIsNull) {
        return `请完善规格「${valuesIsNull.name}」下规格值`;
      }
      const valuesExceed = this.specifications.find(item => {
        return item.values.length > this.specSingleLimit;
      })
      if (valuesExceed) {
        return `规格「${valuesExceed.name}」配置规格值数量已达上限：${this.specSingleLimit}`;
      }
      return result;
    },
    validateSpecValueForm() {
      const valueForms = this.$refs.specValueForm;
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            })
          })
        });
        Promise.all(promiseList).then((results) => {
          const allValid = results.every(result => result);
          if(!allValid) {
            resolve(allValid);
          }
          resolve(true);
        }).catch(() => {
          console.log('validateSpecValueForm has Error')
          resolve(false);
        })
      })
    },
    hanldeSelectorFocus(valueItemRule) {
      const { needPagingQueryValue = false, hasPagingQuery = false, sellPropertyId } = valueItemRule;
      if (needPagingQueryValue === true && hasPagingQuery === false) {
        // 调用接口二次查询属性值
        this.getCascadeValues(sellPropertyId).then((propertyValues = []) => {
          const newPropertyValues = propertyValues.map(item => {
            const { propertyValueId, propertyValueName } = item;
            return {
              sellPropertyValueName: propertyValueName,
              sellPropertyValueId: propertyValueId,
            }
          })
          valueItemRule.propertyValues = cloneDeep(newPropertyValues);
          valueItemRule.hasPagingQuery = true;
          valueItemRule._update = true;
        })
      }
      // 重新筛选
      this.handleSearchPropertyValues('', valueItemRule);
    },
    fieldChanged() {
      // this.getNeedSize();
      this.$emit('fieldChanged');
    },
    async handleAddSpName() {
      const specifications = cloneDeep(this.specifications);
      const matchIndex = specifications.length;
      // 先判断还有没有必填的规格，如果有必填的规格，则直接填充必填规格不可编辑
      const filterRequiredList = this.unrenderRequiredSpecList;
      if (filterRequiredList.length > 0) {
        const newSpec = await gernerateSpecItem(filterRequiredList[0], {}, this.ruleParams);
        newSpec.nameKey = genkey.get('n');
        this.specifications.push(newSpec);
        this.fieldChanged();
        return false;
      }
      // 如果类目是支持自定义的，则直接填充空白输入框
      if (this.supportPropertyDiy) {
        const newSpec = await gernerateSpecItem({}, {}, this.ruleParams);
        newSpec.nameKey = genkey.get('n');
        this.specifications.push(newSpec);
        this.fieldChanged();
        return false;
      }
      // 找到所有非必填的规格，让用户自行选择
      const filterWaitMachList = this.requiredSpecDetails.filter((item) => {
        // return !item.isRequired
        return !this.specifications.some(spec => {
          return spec.name === item.sellPropertyName;
        })
      });
      if (filterWaitMachList.length > 0) {
        const newSpec = await gernerateSpecItem(filterWaitMachList[0], {}, this.ruleParams);
        newSpec.nameKey = genkey.get('n');
        newSpec.renderType = 'select';
        newSpec.renderOptions = filterWaitMachList;
        this.specifications.push(newSpec);
        this.fieldChanged();
        return false;
      }
    },
    nameChange(s) {
      this.$set(s, 'isEdited', true)
    },
    handleValueChange(v) {
      this.$set(v, 'isEdited', true)
      this.fieldChanged()
    },
    valueInput(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.fieldChanged();
    },
    // 属性备注输入事件
    remarkInput(v, vi, sindex) {
      this.$set(v, 'isEdited', true)
      window.__spcificationRemark_changed = true; // 用于skuList生成时的图片取值规则
    },
    removeSpName(index) {
      this.specifications.splice(index, 1)
      this.specifications?.length && this.$set(this.specifications[0], 'isEdited', true)
    },
    // 添加规格值
    addSpValue(index) {
      // let voidValue = {
      //   value: '',
      //   checked: true,
      //   valueKey: this.$utils.genkey.get('v'),
      //   note: ''
      // }
      // if (index === 0) voidValue.imageUrl = '';
      this.$set(this.specifications[index], 'isEdited', true)
      const { valueItemRule, values } = this.specifications[index];
      const voidValue = gernerateDefaultSpecValueItem(valueItemRule)
      values.push(voidValue);
      this.specifications[index].values = formatSpecValues(values, cloneDeep(valueItemRule));
      window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
      this.fieldChanged();
    },
    // 规格名回车事件
    nameEnter(sindex) {
      let firstInputVm = this.$refs[`${sindex}-0`]; // 当前规格下的第一个规格值输入框
      firstInputVm = firstInputVm ? firstInputVm[0] : firstInputVm;
      if (!firstInputVm) {
        return false;
      } else {
        // 聚焦到第一个
        firstInputVm.focus();
      }
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (!nextInputVm) {
        return false;
      } else {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    // 规格值输入事件
    blurHandle(sindex, vi, e) {
      const _value = e.target.value;
      if (!_value) return this.$message.error('请填写规格值');
      const values = this.specifications[sindex].values;
      let isSame = false;
      values.forEach((item, i) => {
        if (vi !== i && item.value === e.target.value) {
          isSame = true;
        }
      });
      if (isSame) {
        this.$message.error('请勿输入相同规格值');
      }
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      if (this.isPureType) return;
      const _copy = [].concat(this.specifications[sindex].values);
      _copy.splice(index, 1);
      this.$set(this.specifications[sindex], 'isEdited', true)
      this.specifications[sindex].values = _copy;
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.fieldChanged();
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
    },
    imageUploadSuccess(url, v, vi) {
      this.$set(v, 'isEdited', true)
      // 校验规格值图片
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', url)
      this.fieldChanged();
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v) {
      this.$set(v, 'isEdited', true)
      v.imageUrl = '';
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.fieldChanged();
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    changeSelectSpecName() {
      window.__spcificationCheckbox_changed = true;
      this.fieldChanged();
    },
    async getCascadeValues(propertyId) {
      const ruleParams = cloneDeep(this.ruleParams);
      return new Promise(resolve => {
        fxgGetCategoryPropertyValue({
          ...ruleParams,
          propertyId,
        })
          .then(res => {
            if (res.result !== 1) {
              resolve([]);
              return false;
            }
            const { property } = res.data;
            resolve(property.propertyValues || []);
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    handleCascaderValueChange({ label, value, showValue, cpvPathList }, specValueItem) {
      specValueItem.value = label;
      specValueItem.fxgExtra.valueId = value;
      specValueItem.fxgExtra.showValue = showValue;
      specValueItem.fxgExtra.cpvPathList = cpvPathList;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      window.__spcificationCheckbox_changed = specValueItem.valueKey;
      this.fieldChanged();
    },
    handleSearchPropertyValues(query/* , cb */, row) {
      if (!row._propertyValues || row._update) {
        row._propertyValues = [...(row.propertyValues || [])];
        row._update = false;
      }
      let propertyValues = []
      if (query) {
        const result = row._propertyValues.filter(item => item.sellPropertyValueName.indexOf(query) > -1);
        propertyValues = result;

        // if (result.length > 0) {
        //   propertyValues = result;
        // } else {
        //   // if(row.supportDiy) {
        //   //   let newItem = { sellPropertyValueName: query, _created: true };
        //   //   let _createIdx = row._propertyValues.findIndex(item => item._created === true);
        //   //   if (~_createIdx) {
        //   //     row._propertyValues.splice(_createIdx, 1, newItem);
        //   //   } else {
        //   //     row._propertyValues.unshift(newItem);
        //   //   }
        //   // }
        //   propertyValues = row._propertyValues.slice(0, 100);
        // }
      } else {
        propertyValues = row._propertyValues.slice(0, 100);
      }
      // 有用户提工单报错，排查是有重复的选项导致的报错，这里去重处理
      propertyValues = propertyValues.reduce((uniqueValues, item) => {
        if (!uniqueValues.some(val => val.sellPropertyValueName === item.sellPropertyValueName)) {
          uniqueValues.push(item);
        }
        return uniqueValues;
      }, []);
      row.propertyValues = propertyValues;
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  line-height: 24px !important;
}
.block-wrap {
  border: 1px solid #dcdfe6;

  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  ::v-deep .el-checkbox{
    vertical-align: top;
  }
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
.specification-value-flex_img {
  height: auto;
  width: 100%;
}
.is-error  {
  ::v-deep .el-input__inner,.file-img {
    border-color: #F56C6C;
  }
}
::v-deep .el-form-item__error{
  position: relative;
}
</style>
